import type { FormAction } from "src/components/Form/Form.types.ts";
import { erpTranslationsQuery } from "src/system/erpTranslationsQuery.ts";

export const formTranslationsQuery = ({
  resource,
  action,
  tab,
}: {
  resource: string;
  action: FormAction;
  tab?: string;
}) => {
  return erpTranslationsQuery({
    resource,
    tab,
    type: "form",
    formType: action,
  });
};
